import { date_lastmodified } from "../util/date";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faSquareXTwitter,
  faSquareYoutube,
  faSquareInstagram,
} from "@fortawesome/free-brands-svg-icons";
import "../css/Footer.css";

const Footer = () => {
  return (
    <footer className="row footer align-items-center" id="usgsfooter">
      <div className="usgsfootertext col-md-4 col-sm-12 col-xs-12">
        <span style={{ fontSize: "12px" }}>
          <a href="https://www.doi.gov/" target="_blank" rel="noreferrer">
            U.S. Department of the Interior
          </a>{" "}
          |{" "}
          <a href="https://www.usgs.gov/" target="_blank" rel="noreferrer">
            U.S. Geological Survey
          </a>
        </span>
        <br />
      </div>
      <div
        id="usgsfootertext2"
        className="usgsfootertext col-md-4 col-sm-12 col-xs-12"
      >
        <a
          href="https://www.usgs.gov/accessibility.html"
          title="Accessibility Policy (Section 508)"
          target="_blank"
          rel="noreferrer"
        >
          Accessibility
        </a>{" "}
        |{" "}
        <a
          href="https://www.usgs.gov/foia/"
          title="Freedom of Information Act"
          target="_blank"
          rel="noreferrer"
        >
          FOIA
        </a>{" "}
        |{" "}
        <a
          href="https://www.usgs.gov/privacy.html"
          title="Privacy policies of the U.S. Geological Survey."
          target="_blank"
          rel="noreferrer"
        >
          Privacy
        </a>{" "}
        |{" "}
        <a
          href="https://www.usgs.gov/policies_notices.html"
          title="Policies and notices that govern information posted on USGS Web sites."
          target="_blank"
          rel="noreferrer"
        >
          Policies and Notices
        </a>
        <br />
        Page Last Modified: {date_lastmodified()}
        <br />
        Page Contact Information:{" "}
        <a
          href="https://answers.usgs.gov/"
          title="If you have a question or need assistance..."
          target="_blank"
          rel="noreferrer"
        >
          <i>The National Map</i>
        </a>
        <br />
      </div>

      <div className="col-md-4 col-sm-12 col-12 footer-social-links">
        <ul className="social list-unstyled d-flex">
          <li className="follow">Follow</li>
          <li className="facebook">
            <a
              href="https://facebook.com/usgeologicalsurvey"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faSquareFacebook} />
              <span className="visually-hidden">Facebook</span>
            </a>
          </li>
          <li className="twitter">
            <a
              href="https://twitter.com/usgs"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faSquareXTwitter} />
              <span className="visually-hidden">Twitter</span>
            </a>
          </li>
          <li className="youtube">
            <a
              href="https://youtube.com/usgs"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faSquareYoutube} />
              <span className="visually-hidden">YouTube</span>
            </a>
          </li>
          <li className="instagram">
            <a
              href="https://instagram.com/usgs"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faSquareInstagram} />
              <span className="visually-hidden">Instagram</span>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
